"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var results_1 = require("../../../results");

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var timeunits_1 = require("../../../utils/timeunits");

var pattern_1 = require("../../../utils/pattern");

var FRTimeUnitAgoFormatParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(FRTimeUnitAgoFormatParser, _AbstractParserWithWo);

  var _super = _createSuper(FRTimeUnitAgoFormatParser);

  function FRTimeUnitAgoFormatParser() {
    _classCallCheck(this, FRTimeUnitAgoFormatParser);

    return _super.call(this);
  }

  _createClass(FRTimeUnitAgoFormatParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return new RegExp("(?:les?|la|l'|du|des?)\\s*" + "(".concat(constants_1.NUMBER_PATTERN, ")?") + "(?:\\s*(prochaine?s?|derni[e\xE8]re?s?|pass[\xE9e]e?s?|pr[\xE9e]c[\xE9e]dents?|suivante?s?))?" + "\\s*(".concat(pattern_1.matchAnyPattern(constants_1.TIME_UNIT_DICTIONARY), ")") + "(?:\\s*(prochaine?s?|derni[e\xE8]re?s?|pass[\xE9e]e?s?|pr[\xE9e]c[\xE9e]dents?|suivante?s?))?", "i");
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var num = match[1] ? constants_1.parseNumberPattern(match[1]) : 1;
      var unit = constants_1.TIME_UNIT_DICTIONARY[match[3].toLowerCase()];
      var timeUnits = {};
      timeUnits[unit] = num;
      var modifier = match[2] || match[4] || "";
      modifier = modifier.toLowerCase();

      if (!modifier) {
        return;
      }

      if (/derni[eè]re?s?/.test(modifier) || /pass[ée]e?s?/.test(modifier) || /pr[ée]c[ée]dents?/.test(modifier)) {
        timeUnits = timeunits_1.reverseTimeUnits(timeUnits);
      }

      return results_1.ParsingComponents.createRelativeFromRefDate(context.refDate, timeUnits);
    }
  }]);

  return FRTimeUnitAgoFormatParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = FRTimeUnitAgoFormatParser;